import { Button } from '@mantine/core';
import { saveAs } from 'file-saver';
import React, { useEffect, useRef, useState } from 'react';
import { baseUrl } from '../../shared/baseUrl';

const generateFileName = (prefix) => {
    return prefix + ' - ' + new Date()

    // 'YYYY MMM DD, h：mm A'
}

const RequestMyData = () => {
    const [isLoading, setIsLoading] = useState(false)

    const accessToken = useRef()

    const token = new URLSearchParams(document.location.search).get('access_token')

    console.log('Access token', accessToken.current)

    useEffect(() => {
        if (token === null || token === '') {
            window.location.href = "/"
        } else {
            accessToken.current = token
            const url = new URL(window.location);
            url.searchParams.set('access_token', '');
            window.history.pushState(null, '', url.toString());
            downloadData()
        }
    }, [])

    if (token === null) {
        return null
    }

    const downloadData = async () => {
        setIsLoading(true)

        const resp = await fetch(baseUrl + 'request-my-data', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                'Authorization': 'Bearer ' + accessToken.current
            }
        })
        let data = await resp.arrayBuffer();
        const blob = new Blob([data], {
            type: 'application/pdf',
        })
        const fileName = generateFileName('My Data') + '.pdf'
        saveAs(blob, fileName)
        // const response = await resp.json()

        // if (response.success) {
        //     createNotification('success', response.message[0]);
        //     localStorage.removeItem(TOKEN_KEY);
        //     localStorage.removeItem(SELECTED_CITY);
        //     dispatch(changeUser(null));
        //     navigate('/')
        // }
        // else {
        //     createNotification('error', "There was some issue deactivating your account.");
        // }

        setIsLoading(false)
    }


    return <div style={{ height: "80vh" }} className='d-flex flex-wrap w-100 justify-content-center align-items-center'>
        <div className='small shadow p-4' style={{ borderRadius: 10, maxWidth: "60vh", }}>
            <div className='text-center'>
                <img alt="logo" style={{ objectFit: "contain", height: "8vh", width: "8vh", filter: "revert", tintColor: 'gray' }} src="/assets/images/logo.png" />

                <p className='mb-0 fw-bold lead'>Your data will be downloaded.</p>
                <p className='mb-5 small text-muted'>(This might take some time depending upon your data.)</p>
            </div>
            <p className='mb-0 text-muted'>If your data is not downloaded yet, press below.</p>

            <div className='d-flex justify-content-center'>
                <Button
                    loading={isLoading}
                    disabled={isLoading}
                    onClick={downloadData}
                    className='mt-3'
                    style={{ background: "#d1027e" }}
                >
                    Download
                </Button>
            </div>
        </div>
    </div>
}

export default RequestMyData